import { render, staticRenderFns } from "./BaseViewToggle.vue?vue&type=template&id=4bb51a80&scoped=true"
import script from "./BaseViewToggle.vue?vue&type=script&lang=js"
export * from "./BaseViewToggle.vue?vue&type=script&lang=js"
import style0 from "./BaseViewToggle.vue?vue&type=style&index=0&id=4bb51a80&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb51a80",
  null
  
)

export default component.exports